var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-view"},[_c('div',{staticClass:"bg"},[_vm._t("bg")],2),_c('div',{class:{'nav-bg':true, ..._vm.classes},style:(_vm.backgroundColor||_vm.zIndex ? {backgroundColor: _vm.backgroundColor,zIndex: _vm.zIndex} : {})}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }